import { authService } from '@/services/authService';
import { defineStore } from 'pinia';

interface UserState {
  vorname: string;
  nachname: string;
  email: string;
  adminKz: boolean;
  supportKz: boolean;
  verbraucherKz: boolean;
  rollen?: Array<{
    mandant: string;
    typ: number;
    name?: string;
  }>;
  standorte?: Array<{
    mandant: string;
    nr: string;
    name?: string;
  }>;
}

const USER_INFO_KEY = 'user_info';

export const useUserStore = defineStore('user', {
  state: (): UserState => {
    // Versuche gespeicherte Daten zu laden
    const savedData = localStorage.getItem(USER_INFO_KEY);
    if (savedData && authService.hasToken()) {
      return JSON.parse(savedData);
    }
    return {
      vorname: '',
      nachname: '',
      email: '',
      adminKz: false,
      supportKz: false,
      verbraucherKz: false,
      rollen: [],
      standorte: []
    };
  },

  getters: {
    fullName: (state): string => {
      // Nur zurückgeben wenn ein gültiger Token existiert
      return authService.hasToken() ? `${state.vorname} ${state.nachname}`.trim() : '';
    },
    isUserInfoSet: (state): boolean => {
      return authService.hasToken() && !!state.vorname && !!state.nachname && !!state.email;
    }
  },

  actions: {
    setUserInfo(
      vorname: string,
      nachname: string,
      email: string,
      adminKz: boolean = false,
      supportKz: boolean = false,
      verbraucherKz: boolean = false,
      rollen: Array<{
        name?: string;
        typ: number;
        mandant: string;
      }> = [],
      standorte: Array<{
        mandant: string;
        nr: string;
        name?: string;
      }>
    ) {
      this.vorname = vorname;
      this.nachname = nachname;
      this.email = email;
      this.adminKz = adminKz;
      this.supportKz = supportKz;
      this.verbraucherKz = verbraucherKz;
      this.rollen = rollen;
      this.standorte = standorte;
      // Speichere im localStorage
      localStorage.setItem(
        USER_INFO_KEY,
        JSON.stringify({
          vorname,
          nachname,
          email,
          adminKz,
          supportKz,
          verbraucherKz,
          rollen,
          standorte
        })
      );
    },

    clearUserInfo() {
      this.vorname = '';
      this.nachname = '';
      this.email = '';
      this.adminKz = false;
      this.supportKz = false;
      this.verbraucherKz = false;
      this.rollen = [];
      // Entferne aus localStorage
      localStorage.removeItem(USER_INFO_KEY);
    },

    // Initialisiere Store mit gespeicherten Daten
    init() {
      const savedData = localStorage.getItem(USER_INFO_KEY);
      if (savedData && authService.hasToken()) {
        const data = JSON.parse(savedData);
        this.setUserInfo(
          data.vorname,
          data.nachname,
          data.email,
          data.adminKz || false,
          data.supportKz || false,
          data.verbraucherKz || false,
          data.rollen || [],
          data.standorte || []
        );
      }
    }
  }
});
